// extracted by mini-css-extract-plugin
export default {"Actor":"Tag_Actor__0vEqf","TranslateName":"Tag_TranslateName__XYGDk","Name":"Tag_Name__e3SMD","Image":"Tag_Image__vDE2M","Info":"Tag_Info__+8-sm","Dot":"Tag_Dot__HX4vH"};